{
  "name": "@devvit/public-api",
  "version": "0.12.11-dev",
  "license": "BSD-3-Clause",
  "repository": {
    "type": "git",
    "url": "https://developers.reddit.com/"
  },
  "type": "module",
  "exports": {
    ".": "./dist/index.js",
    "./package.json": "./package.json",
    "./*": "./dist/*"
  },
  "main": "./dist/index.js",
  "files": [
    "dist/**"
  ],
  "scripts": {
    "build": "yarn build:icon-types && yarn build:semantic-colors && tsc && cp -af devvit.tsconfig.json dist/ && yarn build:min",
    "build:icon-types": "make-icons src/types/icons.ts",
    "build:min": "esbuild --bundle --sourcemap=linked --target=es2020 --format=esm  --metafile=dist/meta.min.json --outfile=dist/public-api.min.js --external:@devvit/protos --minify src/index.ts",
    "build:semantic-colors": "node scripts/make-semantic-colors.js",
    "clean": "rm -rf .turbo coverage dist src/devvit/internals/semanticColors.ts src/types/icons.ts || :",
    "clobber": "yarn clean && rm -rf node_modules",
    "dev:build": "chokidar ./src ../shared-types/dist --command 'yarn build' --ignore './src/types/icons.ts' --ignore './src/devvit/internals/semanticColors.ts'",
    "lint": "redlint .",
    "lint:fix": "yarn lint --fix",
    "prepublishOnly": "publish-package-json",
    "test": "yarn test:unit && yarn test:types && yarn test:size",
    "test:size": "filesize",
    "test:types": "tsc --noEmit",
    "test:unit": "vitest run",
    "test:unit-with-coverage": "vitest run --coverage"
  },
  "types": "./dist/index.d.ts",
  "dependencies": {
    "@devvit/metrics": "0.12.11-dev",
    "@devvit/protos": "0.12.11-dev",
    "@devvit/shared": "0.12.11-dev",
    "@devvit/shared-types": "0.12.11-dev",
    "base64-js": "1.5.1",
    "clone-deep": "4.0.1",
    "moderndash": "4.0.0"
  },
  "devDependencies": {
    "@ampproject/filesize": "4.3.0",
    "@devvit/repo-tools": "0.12.11-dev",
    "@devvit/tsconfig": "0.12.11-dev",
    "@reddit/faceplate-ui": "18.2.2",
    "@reddit/rpl-styles": "1.0.2",
    "@types/clone-deep": "4.0.1",
    "@types/node": "20.14.12",
    "chokidar-cli": "3.0.0",
    "esbuild": "0.25.9",
    "eslint": "9.11.1",
    "typescript": "5.8.3",
    "vitest": "4.0.15"
  },
  "publishConfig": {
    "directory": "dist"
  },
  "filesize": {
    "dist/public-api.min.js": {
      "gzip": "65 KB",
      "none": "225 KB"
    }
  },
  "source": "./src/index.ts"
}
